export const PRODUCER_COLORS = [
  '#1E3A5F',
  '#6B7FA8',
  '#1E4D91',
  '#2C5282',
  '#3E6DAF',
  '#5B8FC9'
];
